var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["ui-carousel", { "ui-carousel-breakpoint": _vm.useBreakpoint }] },
    [
      _vm.showCarouselControls
        ? _c("ui-carousel-controls", {
            attrs: {
              variant: _vm.variant,
              atEnd: _vm.atEnd,
              atStart: _vm.atStart,
            },
            on: { click: _vm.handleOnControlClick },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: _vm.trackRef,
          class: [
            "carousel-track",
            _vm.trackClassName,
            {
              "justify-content-center":
                _vm.isMultiImage && !_vm.showCarouselControls,
            },
          ],
          on: { scroll: _vm.handleOnTrackScroll },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }